import { Link } from "react-router-dom";
import { CalendarCheck2, ArrowRight } from "lucide-react";

const CTASection = ({
  heading = "Bring School Smiles Australia to your school",
  description = "Speak with our team about organising a convenient mobile dental visit for your students.",
  primaryHref = "/for-schools#enquiry",
  primaryLabel = "Request a School Visit",
  secondaryHref = "/contact",
  secondaryLabel = "Contact Our Team",
  testIdPrefix = "cta",
}) => (
  <section
    className="relative overflow-hidden rounded-[2.5rem] bg-[#14324A] text-white p-10 md:p-16 my-24"
    data-testid={`${testIdPrefix}-section`}
  >
    <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#1677C8]/40 blur-3xl" aria-hidden="true" />
    <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[#23B7C5]/30 blur-3xl" aria-hidden="true" />
    <div className="relative z-10 max-w-3xl">
      <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#FFD45C] bg-white/5 border border-white/10 px-4 py-2 rounded-full">
        Ready when you are
      </span>
      <h2 className="mt-5 font-display font-bold text-3xl md:text-4xl lg:text-5xl leading-tight">
        {heading}
      </h2>
      <p className="mt-4 text-white/75 text-base md:text-lg leading-relaxed">{description}</p>
      <div className="mt-8 flex flex-wrap gap-4">
        <Link to={primaryHref} className="btn-accent" data-testid={`${testIdPrefix}-primary-btn`}>
          <CalendarCheck2 size={18} strokeWidth={2.5} />
          {primaryLabel}
        </Link>
        <Link to={secondaryHref} className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white rounded-full px-6 py-3 md:px-8 md:py-4 font-semibold transition-colors" data-testid={`${testIdPrefix}-secondary-btn`}>
          {secondaryLabel}
          <ArrowRight size={18} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  </section>
);

export default CTASection;
